<script setup>
import { renderRichText2 } from '~/utils/richtext'

const props = defineProps({ blok: Object, slug: String })

// ✅ Lösung 1: Null-Check und Fallback für renderRichText
const copy = computed(() => {
  if (!props.blok?.copy) return ''

  try {
    // Prüfe ob renderRichText verfügbar ist
    if (typeof renderRichText2 === 'function') {
      return renderRichText2(props.blok.copy)
    } else {
      // Fallback: Verwende die copy direkt als String oder extrahiere Text
      return extractPlainText(props.blok.copy)
    }
  } catch (error) {
    console.warn('RenderRichText error:', error)
    // Fallback für den Fall eines Fehlers
    return extractPlainText(props.blok.copy)
  }
})

// Hilfsfunktion um Plain Text aus Rich Text zu extrahieren
function extractPlainText(richTextContent) {
  if (!richTextContent) return ''
  
  if (typeof richTextContent === 'string') {
    return richTextContent
  }
  
  if (richTextContent.content && Array.isArray(richTextContent.content)) {
    return richTextContent.content
      .map(node => {
        if (node.type === 'paragraph' && node.content) {
          return node.content
            .map(textNode => textNode.text || '')
            .join('')
        }
        return ''
      })
      .join(' ')
  }
  
  return ''
}
</script>

<template>
  <div class="grid lg:grid-cols-2 gap-10">
    <div class="overflow-hidden bg-no-repeat rounded-3xl bg-cover fx-box relative">
      <NuxtLink :to="slug">
        <img 
          v-if="blok.image?.filename" 
          :width="imageDimension(blok.image.filename).width"
          :height="imageDimension(blok.image.filename).height"
          loading="eager"
          fetchpriority="high"
          decoding="async"
          class="bg-newdark-750 w-full hover:scale-110 transition duration-300 ease-in-out" 
          :alt="blok.image.alt" 
          :src="blok.image.filename + '/m/'" 
        />
        <div v-else class="bg-orange-200 w-full aspect-square"></div>
      </NuxtLink>
    </div>

    <div class="md:ml-20 lg:ml-0">
      <PostCategories :blok="blok.categories" />
      <NuxtLink :to="slug">
        <h3 class="text-4xl md:text-4xl mt-4 hover:text-primary-100 transition-colors duration-300 ease-in-out">
          {{ blok.title }}
        </h3>
      </NuxtLink>
      <!-- ✅ Verwende v-if um sicherzustellen, dass copy existiert -->
      <div 
        v-if="copy" 
        class="text-lg md:text-xl mt-4 font-light text-white/70 pointer-events-none" 
        v-html="copy"
      ></div>
    </div>
  </div>
</template>
